
export interface NotificacionBundle<T> {
	fechaNotificacion: Date,
	bundle: T[]
}

export const EMPTY_BUNDLE: NotificacionBundle<any> = { fechaNotificacion: null, bundle: null };
